import React, { useState, useEffect } from 'react';
import IVideoState from '../../../../models/State.interface';
import { useVideoContext } from '../../../../store/videoContext';
import { IVideoDetail } from '../../../../models/Video.interface';
import { useTranslation } from 'react-i18next';

// API 호출해서 위스튜디오 조회수 GET
import api from "../../../../api/ajax";
import { ENUM_API_TYPE } from '../../../../enum/API';

function Video(props: {
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    isVideoDetailDialogOpen: boolean;
    videoDetail: IVideoDetail;
}): JSX.Element {
    const { t } = useTranslation();
    const [createdAt, setCreatedAt] = useState('');
    const [viewCount, setViewCount] = useState('');  // const [viewCount, setViewCount] = useState(props.videoDetail.view_count);  // DB에서 가져오는 경우 (폐기)
    const { setVideo }: IVideoState = useVideoContext();
    
    //#region 다이얼로그 띄우기
    async function handleOnClick() {
        if(!props.videoDetail.url) {
            return;
        }

        props.setOpen(true);
        setVideo({ ...props.videoDetail });
    }
    //#endregion

    // API 호출해서 위스튜디오 조회수 GET
    useEffect(() => {
        try {
            if(!props.videoDetail.url) {
                setViewCount('준비중');
                setCreatedAt('준비중');
                return;
            }

            const linkSplit1 = props.videoDetail.url.split('https://wehago.com/westudio/#/embed/'); // 링크의 아이디 앞부분 제거 (예시: https://wehago.com/westudio/#/embed/4TTnqW?mode=timeline)
            const linkSplit2 = linkSplit1[1] ? linkSplit1[1].split('?mode=timeline') : []; // 링크의 아이디 뒷부분 제거 (예시: 4TTnqW?mode=timeline)
            const id = linkSplit2[0];
            const param = '/wetv/vod/info?id=' + id;

            api(ENUM_API_TYPE.GET)
                .get(param)  // 예시: /wetv/vod/info?id=VDoyHQ
                .then((result: any) => {
                    result.json().then((response: any) => {
                        if(response && response.resultCode !== 200) {
                            console.log(response);
                            return;
                        }

                        // 게시일
                        const originalCreatedAt = response.resultData.createdAt;  // 형태: 2021-06-02T07:43:28.000Z
                        const splitCreatedAt = originalCreatedAt ? originalCreatedAt.split("-") : "";
                        const result = splitCreatedAt.length >= 3 ? splitCreatedAt[0] + "." + splitCreatedAt[1] + "." + splitCreatedAt[2].substr(0, 2) : "";
                        setCreatedAt(result);

                        // 조회수
                        const hit = response.resultData.hit;
                        setViewCount(hit);
                    })
                })
                .catch((error) => {
                    console.log(error);
                })
        } catch (error) {
            console.log(error);
        }
    }, [props.videoDetail.url]);  // 현재 동영상의 url이 바뀌면 다른 영상으로 교체된 것이므로 api 재호출

    return (
        <li>
            <div className="video_info" onClick={handleOnClick} style={{ cursor: 'pointer' }}>
                <div className={props.videoDetail.url ? "thumb_bx" : "thumb_bx not_movie"}>
                    <img src={props.videoDetail.image_url} alt={props.videoDetail.video_name} />
                </div>

                <div className="bottom_bx">
                    <strong className="title">{props.videoDetail.video_name}</strong>
                    <p className="sub_txt">{props.videoDetail.contents.replace(/\n/gi, ', ').replace(/-/gi, '')}</p>
                    <dl className="sub_info">
                        <dt>{t("postDate")}</dt>
                        <dd>{createdAt ? createdAt : props?.videoDetail?.created_at}</dd>
                        {
                            viewCount &&
                            <dt>
                                <span className="blind">개정세법 알아보기</span>
                                <span className="sp_evg ico_view"></span>
                            </dt>
                        }
                        <dd>{viewCount}</dd>
                    </dl>
                </div>
                
                <div className="link_video">
                    <span className="blind">개정세법 알아보기</span>
                </div>
            </div>
        </li>
    );
}

export default Video;
